import { Calculation } from 'final-form-calculate'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'
import { MetaRoot } from 'util/metaPath'

import { cirurgiaAnoFields } from './anamnese/model-anamnese'
import { mamografiaDiagnosticaFields } from './indicacao-clinica/model-indicacaoClinica'
import { MamografiaPerguntaField, RequisicaoExameMamografiaFormValues } from './model-mamografia'

export const createMamografiaCalculations = (meta: MetaRoot<RequisicaoExameMamografiaFormValues>): Calculation[] => [
  fezMamografiaCalculator(meta),
  fezRadioterapiaCalculator(meta),
  radioterapiaLocalizacaoCalculator(meta),
  fezCirurgiaMamaCalculator(meta),
  tipoMamografiaCalculator(meta),
]

const fezMamografiaCalculator = (meta: MetaRoot<RequisicaoExameMamografiaFormValues>): Calculation => ({
  field: meta[MamografiaPerguntaField.fezMamografia].absolutePath(),
  updates: {
    [meta[MamografiaPerguntaField.anoUltimaMamografia].absolutePath()]: (
      fezMamografiaValue: RastreioCancerPerguntaOpcaoEnum
    ) => {
      if (fezMamografiaValue !== RastreioCancerPerguntaOpcaoEnum.SIM) {
        return null
      }
    },
  },
})

const fezRadioterapiaCalculator = (meta: MetaRoot<RequisicaoExameMamografiaFormValues>): Calculation => ({
  field: meta[MamografiaPerguntaField.fezRadioterapia].absolutePath(),
  updates: {
    [meta[MamografiaPerguntaField.anoRadioterapiaMamaDireita].absolutePath()]: (
      fezRadioterapiaValue: RastreioCancerPerguntaOpcaoEnum,
      allValues: RequisicaoExameMamografiaFormValues | undefined
    ) => {
      if (fezRadioterapiaValue !== RastreioCancerPerguntaOpcaoEnum.SIM) return null
      return allValues?.[MamografiaPerguntaField.anoRadioterapiaMamaDireita]
    },
    [meta[MamografiaPerguntaField.anoRadioterapiaMamaEsquerda].absolutePath()]: (
      fezRadioterapiaValue: RastreioCancerPerguntaOpcaoEnum,
      allValues: RequisicaoExameMamografiaFormValues | undefined
    ) => {
      if (fezRadioterapiaValue !== RastreioCancerPerguntaOpcaoEnum.SIM) return null
      return allValues?.[MamografiaPerguntaField.anoRadioterapiaMamaEsquerda]
    },
    [meta[MamografiaPerguntaField.radioterapiaLocalizacao].absolutePath()]: (
      fezRadioterapiaValue: RastreioCancerPerguntaOpcaoEnum,
      allValues: RequisicaoExameMamografiaFormValues | undefined
    ) => {
      if (fezRadioterapiaValue !== RastreioCancerPerguntaOpcaoEnum.SIM) return null
      return allValues?.[MamografiaPerguntaField.radioterapiaLocalizacao]
    },
  },
})

const radioterapiaLocalizacaoCalculator = (meta: MetaRoot<RequisicaoExameMamografiaFormValues>): Calculation => ({
  field: meta[MamografiaPerguntaField.radioterapiaLocalizacao].absolutePath(),
  updates: {
    [meta[MamografiaPerguntaField.anoRadioterapiaMamaEsquerda].absolutePath()]: (
      radioterapiaLocalizacaoValue: RastreioCancerPerguntaOpcaoEnum,
      allValues: RequisicaoExameMamografiaFormValues | undefined
    ) => {
      if (radioterapiaLocalizacaoValue === RastreioCancerPerguntaOpcaoEnum.DIREITA) return null
      return allValues?.[MamografiaPerguntaField.anoRadioterapiaMamaEsquerda]
    },
    [meta[MamografiaPerguntaField.anoRadioterapiaMamaDireita].absolutePath()]: (
      radioterapiaLocalizacaoValue: RastreioCancerPerguntaOpcaoEnum,
      allValues: RequisicaoExameMamografiaFormValues | undefined
    ) => {
      if (radioterapiaLocalizacaoValue === RastreioCancerPerguntaOpcaoEnum.ESQUERDA) return null
      return allValues?.[MamografiaPerguntaField.anoRadioterapiaMamaDireita]
    },
  },
})

const fezCirurgiaMamaCalculator = (meta: MetaRoot<RequisicaoExameMamografiaFormValues>): Calculation => {
  return {
    field: meta[MamografiaPerguntaField.fezCirurgiaMama].absolutePath(),
    updates: cirurgiaAnoFields.reduce((acc, field) => {
      acc[meta[field].absolutePath()] = (fezCirurgiaMama: boolean) => {
        if (!fezCirurgiaMama) {
          return null
        }
      }
      return acc
    }, {} as Record<string, (fezCirurgiaMama: boolean) => null | undefined>),
  }
}

const tipoMamografiaCalculator = (meta: MetaRoot<RequisicaoExameMamografiaFormValues>): Calculation => {
  return {
    field: meta[MamografiaPerguntaField.tipoMamografia].absolutePath(),
    updates: mamografiaDiagnosticaFields.reduce(
      (acc, field) => {
        acc[meta[field].absolutePath()] = (tipoMamografiaValue: RastreioCancerPerguntaOpcaoEnum) => {
          if (tipoMamografiaValue === RastreioCancerPerguntaOpcaoEnum.RASTREAMENTO) return null
        }
        return acc
      },
      {
        [meta[MamografiaPerguntaField.mamografiaRastreamento].absolutePath()]: (
          tipoMamografiaValue: RastreioCancerPerguntaOpcaoEnum
        ) => {
          if (tipoMamografiaValue === RastreioCancerPerguntaOpcaoEnum.DIAGNOSTICO) return null
        },
        [meta.openedAccordions.absolutePath()]: (tipoMamografiaValue: RastreioCancerPerguntaOpcaoEnum) => {
          if (tipoMamografiaValue === RastreioCancerPerguntaOpcaoEnum.RASTREAMENTO) return []
        },
      }
    ),
  }
}
